export const signupFlowSteps = [
    { num: 1, description: 'Create account' },
    { num: 2, description: 'Verify account' },
    { num: 3, description: 'Select team URL' },
    { num: 4, description: 'Connect bank' },
];
